export function getAbsoluteUrl(relativeUrl, params) {
    if (relativeUrl[0] === '/') throw new Error('url must be relative');
    //applicationConfigurations.baseUrl is being set at index.html by thymeleaf
    const baseUrl = process.env.APPLICATION_BASE_URL
    let url = baseUrl + relativeUrl;
    if (params) {
        url += "?";
        for (let p in params) {
            if (params.hasOwnProperty(p)) {
                url += p + "=" + params[p];
            }
            url += "&";
        }
        //remove last ampersant
        url = url.substring(0, url.length - 1);
    }
    return url;
}
